const symbols = {
  RUB: '₽',
  USD: '$',
  EUR: '€'
}
const symbolsPre = ['USD', 'EUR']

interface Plan {
  price: number
  currency: keyof typeof symbols
}

export function pricing_text(plan: Plan, month_msg: string) {
  if (symbolsPre.includes(plan.currency)) {
    return `${symbols[plan.currency]}${plan.price}/${month_msg}`
  } else {
    return `${plan.price} ${symbols[plan.currency]}/${month_msg}`
  }
}
